"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotBetween = void 0;
const is_between_1 = require("./is-between");
exports.isNotBetween = (value, a, b) => !is_between_1.isBetween(value, a, b);
//# sourceMappingURL=is-not-between.js.map